module.exports = __webpack_public_path__ + "img/piscina.71266caa.webp";